export const Admin_Id = 123;